class CountyListRequestModel {

    constructor(params) {

        if (typeof params === 'undefined') {
            return;
        }

    }

}

export default CountyListRequestModel;